import { render, staticRenderFns } from "./AboutTopStrip.vue?vue&type=template&id=f45c30b2&scoped=true"
import script from "./AboutTopStrip.vue?vue&type=script&lang=js"
export * from "./AboutTopStrip.vue?vue&type=script&lang=js"
import style0 from "./AboutTopStrip.vue?vue&type=style&index=0&id=f45c30b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45c30b2",
  null
  
)

export default component.exports